import { useEffect, useState } from 'react';

export default function AnimatedDots({
  text = 'Thinking',
  intervalMs = 500,
  maxDots = 3
}) {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount(c => (c % maxDots) + 1);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs, maxDots]);

  return (
    <span>
      {text}
      {'.'.repeat(dotCount)}
    </span>
  );
}